import { type SelectLogParams, sendLog, type SelectEventActionType } from '~/apis/log';

export const sendSelectLog = (actionType: SelectEventActionType, params: SelectLogParams) => {
  return sendLog({
    ...params,
    event_type: 'select',
    event_action: actionType,
  });
};
